import React, { useState } from "react";
// material
import { styled } from "@mui/material/styles";
import {
  Toolbar,
  Stack,
  Typography,
  Dialog,
  Button,
  DialogTitle,
} from "@mui/material";
import { postApprovedSettlement } from "../../services/settlements";

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 70,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

const CustomToolbar = ({ pk_list, onSubmit }) => {
  const [openDialog, setOpenDialog] = useState(false);

  function handleApprove(pk_list) {
    postApprovedSettlement({ pk_list });
    setOpenDialog(false);
    setTimeout(() => onSubmit(), 1000);
  }

  return (
    <RootStyle
      sx={{
        ...(pk_list.length > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      {pk_list.length > 0 && (
        <Stack
          direction="row"
          sx={{ width: "100%" }}
          justifyContent={"between"}
          display="flex"
        >
          <Typography variant="subtitle1" sx={{ my: "auto" }}>
            {pk_list.length} selected
          </Typography>
          <Button
            variant="contained"
            color="success"
            onClick={() => setOpenDialog(true)}
            sx={{ ml: "auto" }}
          >
            Approve
          </Button>
        </Stack>
      )}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <Stack
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 2,
            alignItems: "center",
            bgcolor: "primary.main",
          }}
        >
          <DialogTitle sx={{ color: "#fff" }}>Approve?</DialogTitle>
          <Stack direction="row" spacing={2} sx={{ height: 35, mb: 2 }}>
            <Button
              variant="contained"
              color="error"
              onClick={() => setOpenDialog(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => handleApprove(pk_list)}
            >
              Approve
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </RootStyle>
  );
};

export default CustomToolbar;
